import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import ButtonCta from '@components/atoms/button-cta'
import RenderRichText from '@components/renderers/render-rich-text'
import { useEffect, useState } from 'react'
import useResizeObserver from '@hooks/useResizeObserver'
import useStyles from './tab-panel-variant.styles'

const TabPanelVariant = (props) => {
  const {
    tabValue,
    tabIndex,
    accordionDetailHeading,
    accordionDetailLongBlurb,
    firstDetailHeadline,
    firstDetailBlurb,
    secondDetailHeadline,
    secondDetailBlurb,
    richTextBlurb,
    lowerDetailHeadline,
    lowerDetailSubtitle,
    accordionDetailCtaLabel,
    accordionDetailCtaLink,
  } = props

  const [ref, entry] = useResizeObserver()
  const [offset, setOffset] = useState(0)

  const styles = useStyles({ offset })
  useEffect(() => {
    if (entry?.contentRect?.height) {
      setOffset(entry.contentRect.height)
    }
  }, [entry?.contentRect?.height])

  return (
    <Box
      role="tabpanel"
      hidden={tabValue !== tabIndex}
      id={`fullheight-tablist-panel-${tabIndex}`}
      aria-labelledby={`fullheight-tablist-panel-${tabIndex}`}
    >
      {tabValue === tabIndex && (
        <Box sx={{ p: 3 }} className={styles.tabPanel}>
          <Box className={styles.top}>
            <Typography variant="h3" className={styles.tabPanelHeading}>
              {accordionDetailHeading}
            </Typography>
            <Typography className={styles.tabPanelsupportiveCopy}>
              {accordionDetailLongBlurb}
            </Typography>
          </Box>
          <Box className={richTextBlurb ? `${styles.middle} ${styles.richTextWrapper}` : `${styles.middle}`}>
            {richTextBlurb
              ? <RenderRichText {...richTextBlurb} />
              : (
                <>
                  <Box className={styles.left}>
                    <Typography variant="h6">{firstDetailHeadline}</Typography>
                    <Typography variant="body1">{firstDetailBlurb}</Typography>
                  </Box>
                  <Box className={styles.right}>
                    <Typography variant="h6">{secondDetailHeadline}</Typography>
                    <Typography variant="body1">{secondDetailBlurb}</Typography>
                  </Box>
                </>
              )
            }
          </Box>
          <Box ref={ref} className={styles.bottom}>
            <Box className={styles.bottomText}>
              <Typography variant="body1">{lowerDetailHeadline}</Typography>
              <RenderRichText {...lowerDetailSubtitle} />
            </Box>
            <ButtonCta
              variant="text"
              arrow
              href={accordionDetailCtaLink}
              className={styles.ctaButton}
            >
              {accordionDetailCtaLabel}
            </ButtonCta>
          </Box>
        </Box>
      )}
    </Box>
  )
}

TabPanelVariant.propTypes = {
  tabValue: PropTypes.number,
  tabIndex: PropTypes.number,
  accordionDetailHeading: PropTypes.string,
  accordionDetailLongBlurb: PropTypes.string,
  firstDetailHeadline: PropTypes.string,
  firstDetailBlurb: PropTypes.string,
  secondDetailHeadline: PropTypes.string,
  secondDetailBlurb: PropTypes.string,
  richTextBlurb: PropTypes.object,
  lowerDetailHeadline: PropTypes.string,
  lowerDetailSubtitle: PropTypes.object,
  accordionDetailCtaLabel: PropTypes.string,
  accordionDetailCtaLink: PropTypes.string,
}

TabPanelVariant.defaultProps = {}

export default TabPanelVariant
